// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const CheckSimple = (props: SVGProps<SVGSVGElement>) => (
	<svg width="1em" height="1em" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			d="M14.905 4.5a.453.453 0 0 0-.312.14l-7.865 7.939-3.32-3.35a.455.455 0 0 0-.65-.007.46.46 0 0 0 .007.656l3.64 3.675a.453.453 0 0 0 .644 0l8.188-8.264a.461.461 0 0 0-.332-.789Z"
			fill="#fff"
		/>
	</svg>
);
export default CheckSimple;
